

import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const VALUES = ['Justice', 'Integrity', 'Solidarity', 'Accessibility', 'Accountability'];

export default function About() {
  return (
    <div>
      <PageHeader
        eyebrow="About Us"
        title="Who We Are"
        subtitle="Singumkhonto Wabasebenzi NPC is an independent workers' support organisation operating throughout South Africa."
      />

      <section className="section">
        <div className="container grid grid-2">
          <div>
            <h2>Our Mission</h2>
            <p>
              To defend and educate South African workers on their labour rights, providing
              accessible paralegal guidance, administrative assistance and accompaniment for
              workers experiencing workplace challenges — regardless of their means.
            </p>
          </div>
          <div>
            <h2>Our Vision</h2>
            <p>
              A South Africa where every worker, in every province and every industry, knows
              their rights and has somewhere to turn when those rights are violated.
            </p>
          </div>
        </div>
      </section>

      <section className="section" style={{ background: '#f7f5ef' }}>
        <div className="container">
          <span className="eyebrow">Core Values</span>
          <h2 style={{ marginTop: 12 }}>What guides our work</h2>
          <div className="grid grid-3" style={{ marginTop: 24 }}>
            {VALUES.map((v) => (
              <div className="card" key={v}><h3>{v}</h3></div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container grid grid-2">
          <div>
            <h2>Community Outreach</h2>
            <p>
              We run outreach programmes in farming communities, churches and townships to
              bring workers' rights education directly to those who need it most.
            </p>
          </div>
          <div>
            <h2>Volunteer Programme</h2>
            <p>
              Our national network of volunteers helps extend our reach into communities
              across all nine provinces.
            </p>
          </div>
        </div>
      </section>

      <section className="dark-section section" style={{ textAlign: 'center' }}>
        <div className="container">
          <h2>How We Actually Support Workers</h2>
          <p style={{ maxWidth: 560, margin: '0 auto 24px' }}>
            Read our full organisational statement — our legal basis, and the step-by-step
            process we follow from case review through to CCMA accompaniment.
          </p>
          <Link to="/how-we-work" className="btn btn-gold">How We Work</Link>
        </div>
      </section>
    </div>
  );
}
